import React from 'react';
import {connect} from 'react-redux';
import Item from './Item';
import PaymentConfigHandler from '/app/src/config/PaymentConfigHandler'

import {AutoMessageModel} from '/app/src/model/AutoMessage/'
import { withRouter } from 'react-router-dom'
import style  from './style.css'
import {history} from '/app/src/store'
import {SelectInput, SVGButton, ToogleInput, Flex, Jibber, UpgradeModal} from '/app/src/component'
import {SortableContainer, SortableElement} from 'react-sortable-hoc'
import arrayMove from 'array-move'
import _ from 'lodash'

class AutoMessage extends Jibber{
    constructor(props){
        super(props);
        this.useState({
            changePrio: false,
            dirtyItems: [],
            url: '',
            visitor: 'all',
            weekDays: [],
            advancedFilter: false,
            automessages:  props.automessages.toList().toJS(),
            showModal: false
        })
        this._renderList = this._renderList.bind(this)
        this._handleFilterChange = this._handleFilterChange.bind(this)

        this._onItemClick = this._onItemClick.bind(this)
        this._onItemEdit = this._onItemEdit.bind(this)
        this._onItemDelete= this._onItemDelete.bind(this)

        this._onSortEnd = this._onSortEnd.bind(this)
        this._onSave = this._onSave.bind(this)
        this.__newOnClick = this.__newOnClick.bind(this)
    }
    componentWillReceiveProps(nextProps) {
        if(!this.props.automessages.equals(nextProps.automessages)){
            this.setAutomessages(nextProps.automessages.toList().toJS())
        }
    }
    componentDidMount(){
        this.props.automessageReadDispatch()
    }

    _onSave(){
        for(var i in this.state.dirtyItems){
            // get the actual index that we save inside dirtyItems lol
            let index = parseInt(this.state.dirtyItems[i], 10)
            let item = this.state.automessages[index]
            this.props.dispatch(AutoMessageModel.update(
                item.id,
                item.message.message,
                item.message.time,
                item.message.visitor,
                item.message.url,
                item.message.days_of_the_week,
                false)
            )
        }
        this.setDirtyItems([])
    }

    _onSortEnd({oldIndex, newIndex, filteredList}){
        /* since we might have a filter list in our hand
         we need to ensure that the index that are going
        to change will be correct to the list that are not filtered.Hence the
        methods below
        */
        let trueOldIndex = filteredList[oldIndex].message.message.priority
        let trueNewIndex = filteredList[newIndex].message.message.priority

        let newSortedLists = arrayMove(this.state.automessages, trueOldIndex, trueNewIndex)
        let dirtyItems = []
        for(var i in newSortedLists){
            let item = newSortedLists[i]
            if(item.message.message.priority !== i) {
                newSortedLists[i].message.message.priority = i
                dirtyItems.push(i)
            }
        }
        this.setAutomessages(newSortedLists)
        this.setDirtyItems(dirtyItems)
    }

    __ensureIndexToPriority(messages){
        let lst = [...messages]
        for(var i in lst){
            let item = lst[i]
            if (!item) continue;
            if(item.message.message.priority === i) continue;

            lst[i].message.message.priority = i
        }
        return lst
    }

    __newOnClick() {
        const limit = PaymentConfigHandler.checkAccess('automessage', 'admin')
        const {automessages} = this.props
        if ( limit !== 'unlimited' && automessages.size + 1 > limit ) {
            this.setShowModal(true)
            return
        }
        this.props.history.push('/clientChat/autoMessage/create')
    }

    _renderList(){
        let sortedLists = this.state.automessages.sort((item1, item2)=>{
            return item1.message.message.priority - item2.message.message.priority
        })
        sortedLists = this.__ensureIndexToPriority(sortedLists)

        const filteredList = _.filter(sortedLists, (item)=>{
            if(this.state.visitor === 'all' ||
                    this.state.visitor === item.message.visitor
                    || item.message.visitor === 'all'){
            }else{
                return false
            }

            if (this.state.url === '*' || this.state.url === '' ||
                this.state.url.indexOf(item.message.url) !== -1){
            }else{
                return false
            }
            if(this.state.weekDays.length){
                if(!this.state.weekDays.every(day => item.message.days_of_the_week.includes(day))){
                    return false
                }
            }
            return true
        })

        const SortableItem = SortableElement(({item, itemIndex}) => {
            if(!item) return null;
            return (
                    <Item
                        item={item}
                        key={item.id}
                        selected={this.props.selected}
                        onClick={this._onItemClick(item.id)}
                        onDeleteClick={this._onItemDelete(item.id)}
                        onEditClick={this._onItemEdit(item.id)}
                        changePrio={this.state.changePrio}
                    />
            )});

        const SortableList = SortableContainer(({items}) => {

            return (
                <ul>
                  {items.map((item, index) => (
                    <SortableItem
                        disabled={!this.state.changePrio}
                        key={`item-${index}`} index={index} item={item} itemIndex={index}/>
                  ))}
                </ul>
              )
        });

        return <SortableList
                    distance={5}
                    useDragHandle={true}
                    items={filteredList} onSortEnd={({oldIndex, newIndex, collection}) => {
                    this._onSortEnd({oldIndex, newIndex, filteredList})
                }}
                />
    }
    _onItemClick(itemId){
        return (event) => {
            if(itemId !== this.props.selected){
                this.props.history.replace('/clientChat/autoMessage/preview/'+itemId)
            }
        }
    }
    _onItemDelete(itemId){
        return (event) => {
            this.props.history.push('/clientChat/autoMessage')
            this.props.dispatch(AutoMessageModel.delete(itemId))
        }
    }
    _onItemEdit(itemId){
        return (event) => {
            this.props.history.replace('/clientChat/autoMessage/edit/'+itemId)
        }
    }
    _renderAddNew(){
        return (
            <Flex
                onClick={ this.__newOnClick }
                center
                basis='40px'
                fontSize='20px'
                fontWeight='500'
                backgroundColor='darkwhite'
                color='black'
                cursor='pointer'
                backgroundHover='lightblue'
                >
                    + Lägg till nytt meddelande
            </Flex>
        )
    }
    _handleFilterChange(event){
        this.setState({[event.target.name]: event.target.value, changed: true})
    }
    _renderFilter(){
        let urls = {'*': 'Alla sidor'}
        _.forEach(this.state.automessages, (item)=>{
            urls[item.message.url]=item.message.url
        })
        /*
        <Flex column hAlignContent='center' w='30%' h='100%' marginRight='20%'>
            <Flex column marginTop='10px' w='80%'>
                    <Flex>Besökare</Flex>
                    <SelectInput
                        values={{'all': 'Alla','first': 'Första besök','recurring': 'Återkommande'}}
                        select={this.state.visitor}
                        onChange={this._handleFilterChange}
                        name='visitor'
                    />
            </Flex>
        </Flex>
        */
        return (
            <Flex column w='100%' shrink={0}>
                <Flex
                    w='100%' hAlignContent='center'
                    borderTop='0.5px solid lightgrey'
                    py='15px' column
                    shrink={0}
                    >
                    <Flex w='100%'>
                        <Flex column w='30%' h='100%' marginLeft='20%'>
                            <Flex column marginTop='10px' w='80%'>
                                <Flex>Filtrera efter sida/url</Flex>
                                <SelectInput
                                    values={urls}
                                    select={this.state.url}
                                    onChange={this._handleFilterChange}
                                    name='url'
                                />
                            </Flex>
                        </Flex>

                    </Flex>
                    <Flex w='100%' vAlignContent='bottom' wrap paddingLeft='20%' paddingRight='20%'>
                        <Flex column>
                            <Flex column marginTop='10px'>
                                <Flex>Välja en dag</Flex>
                                <ToogleInput
                                        singleInput
                                        values={[
                                        {value: 0, label: 'Må'},
                                        {value: 1, label: 'Ti'},
                                        {value: 2, label: 'On'},
                                        {value: 3, label: 'To'},
                                        {value: 4, label: 'Fr'},
                                        {value: 5, label: 'Lö'},
                                        {value: 6, label: 'Sö'}
                                    ]}
                                    active={this.state.weekDays}
                                    name='weekDays'
                                    onChange={this._handleFilterChange}
                                />
                            </Flex>
                        </Flex>
                        <Flex hAlignContent='center' grow vAlignContent='center'>
                            {this.state.changePrio?
                                (
                                <Flex grow hAlignContent='right' vAlignContent='center'>
                                <SVGButton
                                    marginRight='10px'
                                    hover='blue' text='Avbryt' src='/images/Return.svg' border
                                        onClick={()=>
                                            {
                                                this.setChangePrio(false)
                                                this.setAutomessages(this.props.automessages.toList().toJS())
                                            }
                                        }
                                />
                                <SVGButton
                                    hover='blue'
                                    text='Spara Prio' src='/images/Save.svg'
                                    border
                                    onClick={()=>{
                                        this.setChangePrio(false)
                                        this._onSave()
                                }}
                                />
                                </Flex>
                                ):(
                                <Flex grow hAlignContent='right' vAlignContent='center'>
                                <SVGButton hover='blue' text='Ändra Prio' src='/images/ChangeOrder_M.svg' border
                                    onClick={()=>this.setChangePrio(true)}
                                />
                                </Flex>
                                )
                            }
                        </Flex>
                </Flex>
                </Flex>
            </Flex>
    )}
    render() {
        return(
            <Flex column grow>
                <UpgradeModal contentType='automessage'
                    open={this.state.showModal}
                    onClose={ () => this.setShowModal(false)}
                    onClick={ () => history.push('/companySettings/upgrade') }/>
                {this._renderFilter()}
                <Flex width='100%' className={style.Header} basis='40px' vAlignContent='center'
                borderBottom='1px solid lightgrey'
                borderTop='1px solid lightgrey'
                color='black'
                >
                    <Flex center grow ml='1.5em'>Meddelande</Flex>
                    <Flex center basis='20%'>Titel</Flex>
                    <Flex center basis='20%'>Sida/Url</Flex>
                    <Flex center basis='10%'>Prio</Flex>
                    <Flex w='90px' mr='1.5em'/>
                </Flex>
                {this._renderAddNew()}
                <div style={{
                    overflow: 'auto',
                    flexGrow: '1'
                }}>
                    {this._renderList()}
                </div>
            </Flex>
        );
    }
}

const {selector: automessageSelector, dispatcher: automessageRead} = AutoMessageModel.read()

function mapDispatchToProps(dispatch) {
    return {
        automessageReadDispatch: () => dispatch(automessageRead()),
        dispatch: dispatch //Keep this for legacy dispatch pattern. We will eventually map everything to the dispatcher.
    }
}

function mapStateToProps(state, props){
    var selected = -1;
    if(props.match.params['id']){
        selected = parseInt(props.match.params['id'], 10)
    }

    return {
        automessages: automessageSelector(state)['automessages'],
        network: automessageSelector(state)['network'].get('fetched', false),
        selected: selected
    }

}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AutoMessage));



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/AutoMessage/ListScreen/index.js